import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_a631ba79: FaireBrandEntity = {
  token: "b_a631ba79",
  type: "brand",
  name: "Knot & Bow",
  avatarUrl:
    "https://cdn.faire.com/fastly/78ca3f87bdde034ba75d0afd82a476c74a05ab81eed31570206ee13068fba820.jpeg",
  bannerUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/c541ed8130a5c08c2edd3c5f37e0ff5b0815efc9c8ec4b5ba09a740ae56b4e99/1555357322.jpg",
  logoUrl:
    "https://cdn.faire.com/fastly/78ca3f87bdde034ba75d0afd82a476c74a05ab81eed31570206ee13068fba820.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/c541ed8130a5c08c2edd3c5f37e0ff5b0815efc9c8ec4b5ba09a740ae56b4e99/1555357322.jpg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 132,
  isInsider: true,
  description:
    "Committed to American manufacturing, and always favoring quality in our materials, we design classic, festive paper goods and party supplies that elevate simple, everyday celebrations. We believe the basics are beautiful — a sprinkle of confetti, a handful of balloons, and kraft paper gift wrap is all it takes to make a party.\n\nWhen working with outside production partners to bring our designs to life, we are proud to team up with American manufacturers who we know personally, and deliver the highest quality materials and workmanship. Our beautiful birthday candles are dipped by hand from pure beeswax, our greeting cards are printed onto FSC and Green Seal certified eggshell cover stock and paired with a 100% recycled envelope, and our twine is dyed and spun to our specifications in the United States by the same partner we have worked with for well over a decade. \n\nOur team builds and assembles our products by hand and ships everything quickly and with love from our sunny Los Angeles studio. 💛\n\n",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:13.516Z",
    importedBy: "entity-db-cli",
  },
};
